import { types } from 'core/types';

import { ComponentBlock } from '@types';

import { component } from './component';
import { SelectProps, SelectTriggers } from './index';

export const block: ComponentBlock<'select', SelectProps, SelectTriggers> = {
  id: 'select',
  render: component,
  props: {
    name: {
      type: types.string,
    },
    value: {
      type: types.string,
    },
    label: {
      type: types.string,
    },
    placeholder: {
      type: types.string,
    },
    size: {
      type: types.string,
    },
    options: {
      type: types.list,
    },
  },
  triggers: {
    onBlur: {
      name: 'On blur',
      description: 'When the control is unfocused',
    },
  },
};
